"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

const phrases = [
    "Start a Project",
    "Build with Us",
    "Scale Now",
    "Inquire",
    "Let's Talk",
    "Start Building",
    "Bridge the Gap"
];

interface RotatingCTAProps {
    className?: string;
    interval?: number;
}

export default function RotatingCTA({ className = "", interval = 3000 }: RotatingCTAProps) {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % phrases.length);
        }, interval);
        return () => clearInterval(timer);
    }, [interval]);

    return (
        <div className={`relative overflow-hidden inline-flex items-center ${className}`}>
            <AnimatePresence mode="wait">
                <motion.span
                    key={index}
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -20, opacity: 0 }}
                    transition={{ duration: 0.5, ease: "easeInOut" }}
                    className="whitespace-nowrap inline-block"
                >
                    {phrases[index]}
                </motion.span>
            </AnimatePresence>

            {/* Hidden measuring span to maintain width based on longest phrase */}
            <span className="opacity-0 invisible pointer-events-none h-0 w-auto">
                {phrases.reduce((a, b) => a.length > b.length ? a : b)}
            </span>
        </div>
    );
}
